module.exports = __webpack_public_path__ + "static/media/solanum_tuberosum.2c3a60ab.svg";